import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import Main from "@/views/main.vue";
import Login from "@/views/login.vue";
import AdminList from "@/views/member/adminList.vue";
import AccessRequestClientList from "@/views/member/accessRequestClientList.vue";
import AccessRequestCounselList from "@/views/member/accessRequestCounselList.vue";
import ClientList from "@/views/client/list.vue";

import MyClientList from "@/views/client/myClient.vue";
import ClientDetail from "@/views/client/detail.vue";

import SupportCard from "@/views/client/supportCard.vue";
import CounselList from "@/views/counsel/list.vue";
import MyCounselList from "@/views/counsel/myCounsel.vue";
import RecordList from "@/views/counsel/listForRecord.vue";
import CounselDetail from "@/views/counsel/detail.vue";
import CounselListForClient from "@/views/counsel/listForClient.vue";

import CounselTemporaryList from "@/views/counsel/listForTemporary.vue";
import CounselTemporaryDetail from "@/views/counsel/detailForTemporary.vue";

import Group from "@/views/group/list.vue";
import GroupDetail from "@/views/group/detail.vue";
import CounselBulk from "@/views/counsel/bulk.vue";

import Activity from "@/views/activity/list.vue";
import ActivityDetail from "@/views/activity/detail.vue";

import Complain from "@/views/complain/list.vue";
import ComplainDetail from "@/views/complain/detail.vue";

import Item from "@/views/item/list.vue";
import History from "@/views/item/history.vue";
import Statistics from "@/views/statistics/statistics.vue";
import StatisticsActivity from "@/views/statistics/activity.vue";

import Mypage from "@/views/member/myPage.vue";

import newClntList from "@/views/desk/newClientConfirm.vue";
import CounselNewListCheck from "@/views/desk/newCounselConfirm.vue";

import { userStore } from "@/BaseComponent";

const routes: Array<RouteRecordRaw> = [
    { path: "/", name: "Main", component: Main, meta: { requiresAuth: true } },
    {
        path: "/login",
        name: "Login",
        component: Login,
        meta: { requiresAuth: false },
    },
    { path: "/client", name: "client", component: ClientList, meta: { requiresAuth: true, keepAlive: true } },
    { path: "/client/detail/:id", name: "clientDetail", component: ClientDetail, meta: { requiresAuth: true } },
    { path: "/new/client", name: "newClient", component: ClientDetail, meta: { requiresAuth: true } },
    { path: "/new/myClient", name: "myClient", component: MyClientList, meta: { requiresAuth: true, keepAlive: true } },
    { path: "/supportCard/:id", name: "supportCard", component: SupportCard, meta: { requiresAuth: true } },

    { path: "/counsel", name: "counsel", component: CounselList, meta: { requiresAuth: true, keepAlive: true } },
    { path: "/my/counsel", name: "myCounsel", component: MyCounselList, meta: { requiresAuth: true, keepAlive: true } },
    { path: "/record", name: "record", component: RecordList, meta: { requiresAuth: true, keepAlive: true } },
    { path: "/counsel/add/:id", name: "counselAdd", component: CounselDetail, meta: { requiresAuth: true } },
    { path: "/counsel/detail/:id/:idx", name: "counselDetail", component: CounselDetail, meta: { requiresAuth: true } },
    { path: "/counsel/client/:id", name: "counselListForClient", component: CounselListForClient, meta: { requiresAuth: true, keepAlive: true } },
    { path: "/counsel/temporary", name: "temporary", component: CounselTemporaryList, meta: { requiresAuth: true, keepAlive: true } },
    { path: "/counsel/temporary/detail/:id/:idx", name: "temporaryDetail", component: CounselTemporaryDetail, meta: { requiresAuth: true } },

    { path: "/counsel/group", name: "group", component: Group, meta: { requiresAuth: true, keepAlive: true } },
    { path: "/counsel/group/detail/:id", name: "groupDetail", component: GroupDetail, meta: { requiresAuth: true } },
    { path: "/counsel/group/add", name: "groupAdd", component: GroupDetail, meta: { requiresAuth: true } },
    { path: "/counsel/bulk", name: "counselBulk", component: CounselBulk, meta: { requiresAuth: true } },

    { path: "/activity", name: "activity", component: Activity, meta: { requiresAuth: true, keepAlive: true } },
    { path: "/activity/add", name: "activityAdd", component: ActivityDetail, meta: { requiresAuth: true } },
    { path: "/activity/detail/:id", name: "activityDetail", component: ActivityDetail, meta: { requiresAuth: true } },

    { path: "/complain", name: "complain", component: Complain, meta: { requiresAuth: true, keepAlive: true } },
    { path: "/complain/add", name: "complainAdd", component: ComplainDetail, meta: { requiresAuth: true } },
    { path: "/complain/detail/:id", name: "complainDetail", component: ComplainDetail, meta: { requiresAuth: true } },

    { path: "/item", name: "item", component: Item, meta: { requiresAuth: true, keepAlive: true } },
    { path: "/itemHistory/:id", name: "itemHistory", component: History, meta: { requiresAuth: true } },

    { path: "/statistics", name: "statisticsCommon", component: Statistics, meta: { requiresAuth: true } },
    { path: "/statistics/activity", name: "statisticsActivity", component: StatisticsActivity, meta: { requiresAuth: true } },

    { path: "/myPage", name: "myPage", component: Mypage, meta: { requiresAuth: true } },

    { path: "/desk/manage", name: "manage", component: AdminList, meta: { requiresAuth: true, keepAlive: true } },
    { path: "/desk/newClient", name: "newClntList", component: newClntList, meta: { requiresAuth: true, keepAlive: true } },
    { path: "/desk/newCounsel", name: "newCnslList", component: CounselNewListCheck, meta: { requiresAuth: true, keepAlive: true } },
    {
        path: "/desk/accessRequestClient",
        name: "accessRequestClient",
        component: AccessRequestClientList,
        meta: { requiresAuth: true, keepAlive: true },
    },
    {
        path: "/desk/accessRequestCounsel",
        name: "accessRequestCounsel",
        component: AccessRequestCounselList,
        meta: { requiresAuth: true, keepAlive: true },
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior() {
        return { top: 0 };
    },
});

router.beforeEach((to: any, from: any, next: any) => {
    const user = userStore();
    const isLoggedIn = user !== null && user.accessToken;

    if (!isLoggedIn && to.name !== "Login") {
        next({ name: "Login" });
    } else {
        next();
    }
});

export default router;
